import { render, staticRenderFns } from "./EditMaterialCategoryPopup.vue?vue&type=template&id=3ca5cfa1"
import script from "./EditMaterialCategoryPopup.vue?vue&type=script&lang=js"
export * from "./EditMaterialCategoryPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports